import type {DesignerStores} from '@packages/systems/designer/flux';
import {createSelector} from 'reselect';
import {getPage, getPages} from '@packages/shared/utils/PageTreeUtils';
import {isDynPage} from '@packages/shared/utils/PageUtils';

export const selectCurrentPageId = (state: DesignerStores) =>
  state.DesignerStore.currentPageId;

export const selectCurrentPageItemId = (state: DesignerStores) =>
  state.DesignerStore.currentPageItemId;

export const selectPageState = (state: DesignerStores) => state.PageStore;
export const selectPageManagerUIState = (state: DesignerStores) =>
  state.PageManagerUIStore;

export const selectReviews = (state: DesignerStores) =>
  state.ReviewStore.reviews;

export const selectBranchingInProgress = (state: DesignerStores) =>
  state.DesignerStore.pageBranchCreateInProgress;

export const selectPages = createSelector(selectPageState, (pageState) =>
  getPages(pageState)
);
// this now returns a map of {pageId: pageName}
export const selectPageNameMap = createSelector(
  selectPages,
  (pages): Record<string, string> => {
    const map: Record<string, string> = {};
    pages.forEach((p) => {
      map[p.id] = p.name;
    });
    return map;
  }
);

export const selectCurrentPageType = createSelector(
  (state: DesignerStores) => state.PageStore.get('dynamicPages'),
  (state: DesignerStores) => state.PageStore.get('staticPages'),
  (state: DesignerStores) => state.PageStore.get('componentPages'),
  (state: DesignerStores) => state.DesignerStore.currentPageId,
  (dynamicPages, staticPages, componentPages, currentPageId) => {
    if (currentPageId && dynamicPages?.get(currentPageId)) {
      return 'dynamic';
    }
    if (currentPageId && staticPages?.get(currentPageId)) {
      return 'static';
    }
    if (currentPageId && componentPages?.get(currentPageId)) {
      return 'component';
    }
    return null;
  }
);

export type CurrentPageType = ReturnType<typeof selectCurrentPageType>;

export const selectIsDynamicPage = createSelector(
  selectCurrentPageId,
  selectPageState,
  (currentPageId, pageState) => isDynPage(getPage(currentPageId, pageState))
);
